import { useAuthStore } from '../stores/authStore'
import { ForbiddenPage } from '../pages/ForbiddenPage'

interface PermissionGuardProps {
  children: React.ReactNode
  permissions: string[]
  fallback?: React.ReactNode
}

export function PermissionGuard({ children, permissions, fallback = null }: PermissionGuardProps) {
  const hasPermission = useAuthStore((s) => s.hasPermission)
  const allowed = permissions.some((p) => hasPermission(p))

  if (!allowed) {
    return <>{fallback}</>
  }

  return <>{children}</>
}

interface PermissionRouteProps {
  children: React.ReactNode
  permissions: string[]
}

export function PermissionRoute({ children, permissions }: PermissionRouteProps) {
  const hasPermission = useAuthStore((s) => s.hasPermission)
  const allowed = permissions.some((p) => hasPermission(p))

  if (!allowed) {
    return <ForbiddenPage permissions={permissions} />
  }

  return <>{children}</>
}
